function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import cx from 'classnames';
import Tooltip from 'rc-tooltip';
import 'rc-tooltip/assets/bootstrap.css';
var className = 'bg-gray-100 border-b-2 focus:outline-none text-gray-800 font-bold items-center inline-flex justify-center w-10 h-10 transition';

var EditorToolButton = function EditorToolButton(_ref) {
  var _ref2;

  var children = _ref.children,
      title = _ref.title,
      disabled = _ref.disabled,
      active = _ref.active,
      rest = _objectWithoutPropertiesLoose(_ref, ["children", "title", "disabled", "active"]);

  var button = /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("button", _extends({}, rest, {
    className: cx([className, (_ref2 = {}, _ref2[rest.className] = !!rest.className, _ref2['opacity-50 pointer-events-none'] = !!disabled, _ref2['hover:bg-gray-200'] = !disabled, _ref2['text-primary'] = active, _ref2['bg-primary-light'] = active, _ref2['hover:bg-primary-light'] = active, _ref2)])
  }), children));

  if (title) {
    return /*#__PURE__*/React.createElement(Tooltip, {
      mouseEnterDelay: "0.3",
      placement: "left",
      trigger: ['hover'],
      overlay: /*#__PURE__*/React.createElement("span", null, title + " " + (active && '⚫' || ''))
    }, button);
  }

  return button;
};

export default EditorToolButton;